import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchAdditionalPaymentCategoriesQuery } from '@/features/additional-payment-categories'
import { fetchAdditionalPaymentCategoriesList } from '@/features/additional-payment-categories/api'

import { AdditionalPaymentCategoriesSearchSchema } from './-models/additional-payment-categories-search'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/'
)({
  validateSearch: (search) =>
    parse(AdditionalPaymentCategoriesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、isActive=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          isActive: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchAdditionalPaymentCategoriesQuery(tenantKey, deps)
    return {
      authUser: auth.user,
      additionalPaymentCategories: await fetchAdditionalPaymentCategoriesList(
        query,
        abortController.signal
      )
    }
  }
})
